import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import { zonedTimeToUtc } from 'date-fns-tz';
export function getDateAndTimeFromDateTime(dateTime) {
  if (!dateTime) {
    return {
      date: null,
      time: null
    };
  }
  var _Date$toISOString$spl = new Date(dateTime).toISOString().split('T'),
    _Date$toISOString$spl2 = _slicedToArray(_Date$toISOString$spl, 2),
    date = _Date$toISOString$spl2[0],
    time = _Date$toISOString$spl2[1];
  return {
    date: date,
    time: time.slice(0, 5)
  };
}
export function checkIsPastSectionUnlockDateTime(lockingMode, date, time, timezone) {
  if (lockingMode !== 'time' || !date || !time || !timezone) {
    return false;
  }
  var utcDateAndTime = zonedTimeToUtc("".concat(date, " ").concat(time), timezone);
  return utcDateAndTime < new Date();
}